<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-8">
        <h2>Activity Descriptions</h2>
        <ol class="breadcrumb">
          <li>
            Home / Management / Activity Descriptions
          </li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Activity Descriptions</h5>
              <div class="ibox-tools">
                <button
                        class="btn btn-primary btn-xs"
                        @click="openCreateModal">Create New Activity Description</button>
              </div>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th id="template-list-id">No.</th>
                      <th id="template-list-name">Name</th>
                      <th id="template-list-description">Description</th>
                      <th id="template-list-color">Color</th>
                      <th id="template-list-location">Location</th>
                      <th id="template-list-seats">Seats Available</th>
                      <th id="template-list-duration">Duration (Hour)</th>
                      <th id="template-list-duration">Forbidden Time Before Start (Minute)</th>
                      <th id="template-list-delete" />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                        v-for="template in templates"
                        :key="template.id">
                      <td>{{ template.id }}</td>
                      <td>{{ template.name }}</td>
                      <td>{{ template.description }}</td>
                      <td>
                        <span
                              :style="{background: template.color}"
                              style="padding: 7px;  text-align: center; display: inline-block;" />
                        {{ template.color }}</td>
                      <td>{{ template.location }}</td>
                      <td>{{ template.seats_available }}</td>
                      <td>{{ template.duration }}</td>
                      <td>{{ template.forbid_minutes }}</td>
                      <td>
                        <button
                                type="submit"
                                class="btn btn-sm btn-primary"
                                @click="openEditModal(template)">
                          Edit
                        </button>
                        <button
                                type="submit"
                                class="btn btn-sm btn-danger"
                                @click="deleteTemplate(template.id)">
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
         id="templateDeleteModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="regCancelLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Description Deletion Warning
            </h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this description?
              <br><br> Previous created activities will not be affected.</p>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This activity cannot be deleted: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal">No</button>
            <button
                    id="templateDeleteBtn"
                    type="submit"
                    class="btn btn-md btn-danger"
                    @click="confirmDeleteTemplate">Yes</button>
          </div>
        </div>
      </div>
    </div>

    <div
         id="templateCreationModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="eventCreationLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
                id="eventCreationLabel"
                class="modal-title">
              <template v-if="createOrEdit">
                Edit
              </template>
              <template v-else>
                Create
              </template>
              Activity Description</h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <template v-if="createOrEdit">
              <p>
                <b>
                  Note: Editing exist description will not affect previous created activities.
                </b>
              </p>
            </template>
            <form role="form">
              <div class="form-group">
                <label>Name</label>
                <input
                       v-model.trim="newTemplate.name"
                       type="name"
                       placeholder="Enter activity name"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Description</label>
                <textarea
                          v-model.trim="newTemplate.description"
                          type="description"
                          rows="5"
                          placeholder="Enter activity description"
                          class="form-control" />
                </div>
              <div class="form-group">
                <label>Seats Available</label>
                <input 
                  v-model.trim.number="newTemplate.seats_available" 
                  type="number" 
                  min="0" 
                  step="1" 
                  placeholder="Enter the number of seats available" 
                  class="form-control">
              </div>
              <div class="form-group">
                <label>Duration (in Hour)</label>
                <input 
                  v-model.trim.number="newTemplate.duration" 
                  type="number" 
                  placeholder="Enter the duration" 
                  class="form-control">
              </div>
              <div class="form-group">
                <label>Forbidden Time Before Start (in Minute)</label>
                <input 
                  v-model.trim.number="newTemplate.forbid_minutes" 
                  type="number" 
                  placeholder="Enter the time" 
                  class="form-control">
              </div>
              <div class="form-group">
                <label>Location</label>
                <input 
                  v-model.trim="newTemplate.location" 
                  type="text" 
                  placeholder="Enter the location" 
                  class="form-control">
              </div>
              <div class="form-group">
                <label>Color</label>
                <span 
                  :style="{background: newTemplate.color}"
                  style="padding: 7px;  text-align: center; margin-top: 20px; display: inline-block;"
                  class="m-l-md"/>
                <div class="btn-group m-l-md">
                  <button 
                    data-toggle="dropdown" 
                    class="btn btn-default dropdown-toggle"> {{ newTemplate.color }}</button>
                  <ul class="dropdown-menu">
                    <chrome-picker 
                      id="colorpicker" 
                      :value="newTemplate.color" 
                      class="m-t-xs" 
                      @input="updateColor"/>
                  </ul>
                </div>
              </div>
            </form>
            <div 
              v-show="errorShow" 
              class="toast-top-right" 
              style="margin: 0 0 2%;">
              <div 
                class="toast toast-error" 
                style="opacity: 0.69075;">
                <div 
                  class="toast-message" 
                  style="padding: 1%; color: white; font-size: 1.5rem;">
                  This activity cannot be added: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-secondary" 
              data-dismiss="modal">Cancel</button>

            <template v-if="createOrEdit">
              <button 
                id="templateEditBtn" 
                type="submit" 
                class="btn btn-md btn-primary"
                @click="editTemplate()">Edit
              </button>
            </template>
            <template v-else>
              <button 
                id="templateCreationBtn" 
                type="submit" 
                class="btn btn-md btn-primary"
                @click="createTemplate()">Create
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scope>
.ibox-content tbody tr th {
  font-weight: normal;
}
</style>

<script>
import { Chrome } from "vue-color";

export default {
  name: "MyEvents",
  components: {
    "chrome-picker": Chrome
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      getTemplateUrl: "template",
      templates: [],
      currentDeletingTemplateId: 0,
      currentEditingTemplateId: 0,
      createOrEdit: 0,
      newTemplate: {
        name: "",
        description: "",
        seats_available: 0,
        location: "SALL Centre",
        duration: 0,
        color: "",
        forbid_minutes: 0
      },
      errorMessage: "",
      errorShow: false
    };
  },
  mounted () {
    this.fetchTemplateList();
  },
  methods: {
    updateColor (value) {
      this.newTemplate.color = value["hex"];
    },
    fetchTemplateList () {
      const that = this;
      this.$emit("showLoading");
      this.request
        .get(this.getTemplateUrl)
        .then(function (response) {
          that.templates = response.data.templates;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          that.$emit("hideLoading");
          console.log(that.templates);
        });
    },
    openCreateModal () {
      this.newTemplate = {
        name: "",
        description: "",
        seats_available: 0,
        location: "SALL Centre",
        color: "#1ab394",
        forbid_minutes: 0
      };
      this.errorShow = false
      this.errorMessage = ""
      this.createOrEdit = 0;
      $("#templateCreationModal").modal("show");
    },
    createTemplate () {
      $("#templateCreationBtn").button("loading");
      const that = this;
      this.request
        .post("template/", {
          name: this.newTemplate.name,
          description: this.newTemplate.description,
          location: this.newTemplate.location,
          seats_available: this.newTemplate.seats_available,
          duration: this.newTemplate.duration,
          color: this.newTemplate.color,
          forbid_minutes: this.newTemplate.forbid_minutes
        })
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          that.fetchTemplateList();
          setTimeout(function () {
            $("#templateCreationModal").modal("hide");
            $("#templateCreationBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#templateCreationBtn").button("reset");
        });
    },
    openEditModal (template) {
      this.createOrEdit = 1;
      this.currentEditingTemplateId = template.id;
      this.newTemplate = Object.assign({}, template);
      if (!this.newTemplate.color) {
        this.newTemplate.color = "#1ab394";
      }
      this.errorShow = false
      this.errorMessage = ""
      $("#templateCreationModal").modal("show");
    },
    editTemplate () {
      $("#templateEditBtn").button("loading");
      const that = this;
      this.request
        .post(`template/${this.currentEditingTemplateId}`, {
          name: this.newTemplate.name,
          description: this.newTemplate.description,
          location: this.newTemplate.location,
          seats_available: this.newTemplate.seats_available,
          duration: this.newTemplate.duration,
          color: this.newTemplate.color,
          forbid_minutes: this.newTemplate.forbid_minutes
        })
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          that.fetchTemplateList();
          setTimeout(function () {
            $("#templateCreationModal").modal("hide");
            $("#templateEditBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#templateEditBtn").button("reset");
        });
    },
    deleteTemplate (id) {
      this.errorShow = false
      this.errorMessage = ""
      $("#templateDeleteModal").modal("show");
      this.currentDeletingTemplateId = id;
    },
    confirmDeleteTemplate () {
      $("#templateDeleteBtn").button("loading");
      const that = this;
      this.request
        .delete(`template/${this.currentDeletingTemplateId}`)
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          that.fetchTemplateList();
          setTimeout(function () {
            $("#templateDeleteModal").modal("hide");
            $("#templateDeleteBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#templateDeleteBtn").button("reset");
        });
    }
  }
};
</script>

<style>
</style>
